import React from 'react';
import { FormControl } from 'components/form';
import { Intent } from 'constants/ui';
import BaseHint from '../BaseHint';
const FullPermissionContactRequiredToAllowSelectPaymentMethodHint = () => (React.createElement(FormControl, null,
    React.createElement(BaseHint, { intent: Intent.WARNING, text: "There are currently only read-only contacts. To allow a vendor to select their payment method, please include a contact with full permissions above.", title: "A full permissions contact is required" })));
export default FullPermissionContactRequiredToAllowSelectPaymentMethodHint;
